import { Controller } from "@hotwired/stimulus"

// Preserves scroll position and open <details> elements across form
// submissions that trigger a full page redirect. Attach to a wrapper
// element and it saves/restores scroll position automatically.
//
// Usage:
//   <div data-controller="scroll-preserve" data-scroll-preserve-key-value="my-section">
//     <details data-scroll-preserve-target="details">...</details>
//     <form data-action="submit->scroll-preserve#save">...</form>
//     <button data-action="click->scroll-preserve#save">Discard</button>
//   </div>
//
export default class extends Controller {
  static values = { key: String }
  static targets = ["details"]

  connect() {
    const stored = sessionStorage.getItem(this.storageKey)
    if (!stored) return

    sessionStorage.removeItem(this.storageKey)
    const data = JSON.parse(stored)

    // Restore scroll position after a brief delay to let the page render
    requestAnimationFrame(() => {
      window.scrollTo({ top: data.scrollY, behavior: "instant" })
    })

    // Re-open any details elements that were open
    if (data.detailsOpen) {
      this.detailsTargets.forEach((el) => {
        el.open = true
      })
    }
  }

  save() {
    const data = {
      scrollY: window.scrollY,
      detailsOpen: this.detailsTargets.some((el) => el.open),
    }
    sessionStorage.setItem(this.storageKey, JSON.stringify(data))
  }

  get storageKey() {
    return `scroll-preserve-${this.keyValue || "default"}`
  }
}
